import React, { useId } from "react";

const Toggle = ({ checked, onChange, label, hint, disabled, name }) => {
  const inputId = useId();
  return (
    <label className="pf-toggle" htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        name={name}
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="pf-toggle__track" aria-hidden="true">
        <span className="pf-toggle__thumb" />
      </span>
      <span>
        <span className="pf-toggle__label">{label}</span>
        {hint ? <div className="pf-toggle__hint">{hint}</div> : null}
      </span>
    </label>
  );
};

export default Toggle;
